/* Page to fetch the Shooting Schedule Days Episodes */
import React, {
  useCallback,
  useEffect,
  // useLayoutEffect,
  useState,
} from "react";

import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { axiosInstance } from "../../api/axiosDefaults";
import TopBox from "../../components/TopBox";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import EpisodeList from "../episodes/EpisodeList";
import btnStyles from "../../styles/Button.module.css";
import styles from "../../styles/Scene.module.css";
import "react-calendar/dist/Calendar.css";

const ScheduleDaysEpisode2 = () => {
  const currentUser = useCurrentUser();
  // const queryString = window.location.search;
  const callEpi = true;

  // const projectType = currentUser?.project_category_type
  //   ? JSON.parse(currentUser?.project_category_type)
  //   : null;

  // Use URLSearchParams to parse the query string
  // const params = new URLSearchParams(queryString);

  const [episodes, setEpisodes] = useState([]);

  const history = useHistory();

  const fetchEpisodes = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${localStorage.getItem("projectSlug")}/scene_episodes/`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );

      setEpisodes(data.results);
    } catch (error) {
      console.log("schedule error: ", error);
    }
  };

  useEffect(() => {
    fetchEpisodes();
  }, []);

  const getLink = useCallback((episode) => {
    // Add null/undefined check for episode
    if (!episode) return "/";

    return `/${localStorage.getItem("projectSlug")}/days2unit?episode=${
      episode.id
    }&project=${episode.project}&episodeTitle=${encodeURIComponent(
      episode.episode_number
    )}`;
  }, []);

  return (
    <div>
      <TopBox 
      second="2ND UNIT"
        title="Schedule"
       />
      {/* back info */}
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} mb-1 mt-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <h3 className="text-center">Select Episode</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      <EpisodeList
        callEpi={callEpi}
        currentUser={currentUser}
        episodes={episodes}
        getLink={getLink}
      />
    </div>
  );
};

export default ScheduleDaysEpisode2;